<template>
    <div>

        <!-- Competencies view -->

        <trax-ui-card-icon-header 
            :icon="icon" :header-color="headerColor" :title="title">

            <enac-procedure-atp-daf-edit-competencies-view :id="id+'-competencies'" :bus="bus" 
                :states="states" :indicators="indicators" :edit-disabled="disabled || !atpLaunchPermission">
            </enac-procedure-atp-daf-edit-competencies-view>

        </trax-ui-card-icon-header>

            
        <!-- Competencies modal -->

        <trax-ui-modal-plain-header :id="id+'-competencies-select'" :bus="bus" size="lg" v-show="!disabled">
            <enac-procedure-atp-daf-edit-competencies-select :id="id+'-competencies-select'" :bus="bus">
            </enac-procedure-atp-daf-edit-competencies-select>
        </trax-ui-modal-plain-header>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            source: {default: '2'},
            target: {default: 'final'},
            icon: null,
            headerColor: null,
            title: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                states: {},
                indicators: data.general_criteria_names,
                disabled: false,
                bus: this.$bus
            }
        },
        
        computed: {

            atpLaunchPermission: function() {
                if (this.user.admin || this.user.permissions['procedure.write-atp']) return true;
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                return userFunction == 'training' || userFunction == 'training_op';
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
            this.bus.$on(this.id+'-'+this.source+'-save', this.saveData);
            this.bus.$on(this.id+'-competencies-select-set', this.setSelect);
        },

        methods: {

            setData(procedure) {
                if (!procedure.data.atp_launch || !procedure.data.atp_launch.competencies) return;
                this.states = procedure.data.atp_launch.competencies;
                if (this.states.length === 0) this.states = {};
                this.disabled = (procedure.data.atp_launch_submit != undefined);
            },

            setSelect(data) {
                this.states[data.type_code] = data.states;
                for (var id in data.indicators) this.indicators[id] = data.indicators[id]; 
                this.bus.$emit(this.id+'-competencies-view-force-update');
            },

            saveData(data) {
                data.data.atp_launch.competencies = this.states;
                this.bus.$emit(this.id+'-'+this.target+'-save', data);
            }
        }
    }
</script>
